import { Group } from '@mantine/core';
import { Button as IncidentButton } from '@repo/foundations';
import { isNil } from 'lodash-es';
import type { Incident, IncidentStatus } from '../../../../api';
import {
	isAcknowledgeEnabled,
	isResolveEnabled,
} from '../../../../pages/IncidentPage/utils';

export interface MonitorIncidentActionsProps {
	incident?: Incident | null;
	onUpdateIncident: (
		status: Exclude<IncidentStatus, 'active' | 'expired'>
	) => Promise<void>;
}

export function MonitorIncidentActions({
	incident,
	onUpdateIncident,
}: MonitorIncidentActionsProps) {
	const handleIncidentStatusUpdate = (status: IncidentStatus) => async () => {
		if (!incident?.id) {
			return;
		}

		if (status === 'active' || status === 'expired') {
			return;
		}

		await onUpdateIncident(status);
	};

	const showAcknowledgeButton = isAcknowledgeEnabled(incident?.status);
	const showResolveButton = isResolveEnabled(incident?.status);

	if (isNil(incident) || (!showAcknowledgeButton && !showResolveButton)) {
		return null;
	}

	return (
		<Group spacing="xs">
			{showResolveButton && (
				<IncidentButton
					onClick={handleIncidentStatusUpdate('resolved')}
					disabled={!isNil(incident.resolved_at)}
					variant={showAcknowledgeButton ? 'default' : 'primary'}
					size="md"
				>
					Resolve
				</IncidentButton>
			)}
			{showAcknowledgeButton && (
				<IncidentButton
					onClick={handleIncidentStatusUpdate('acknowledged')}
					disabled={!isNil(incident.acknowledged_at)}
					variant="primary"
					size="md"
				>
					Acknowledge
				</IncidentButton>
			)}
		</Group>
	);
}
